import React from 'react';

import SuperSearchDropdown from 'NewComponents/FormComponents/SuperSearchDropdown/SuperSearchDropdown';
import PayerSuperSearchInput from './PayerSuperSearchInput';
import PayerSuperSearchTemplate from './PayerSuperSearchTemplate';

const PayerSuperSearch = ({ searchValue, onChange, handleSelectedData, disabled }) => {
  return (
    <SuperSearchDropdown handleSelectedData={handleSelectedData}>
      <SuperSearchDropdown.Input>
        <PayerSuperSearchInput
          disabled={disabled}
          searchValue={searchValue}
          onChange={onChange}
          handleSelectedData={handleSelectedData}
          identifier='PayerSuperSearch'
          placeholder='Search Payer...'
        />
      </SuperSearchDropdown.Input>
      <SuperSearchDropdown.Container>
        <PayerSuperSearchTemplate
          width='100%'
          handleSelectedData={handleSelectedData}
          identifier='PayerSuperSearch'
        />
      </SuperSearchDropdown.Container>
    </SuperSearchDropdown>
  );
};

export default PayerSuperSearch;
